import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: string;
  AWSDateTime: string;
  AWSEmail: string;
  AWSIPAddress: string;
  AWSJSON: string;
  AWSPhone: string;
  AWSTime: string;
  AWSTimestamp: number;
  AWSURL: string;
};

export type CreateEntityInput = {
  data: Scalars['AWSJSON'];
  deleteDt: InputMaybe<Scalars['String']>;
  entityKey: Scalars['String'];
  entityName: EntityName;
  gsiKey: InputMaybe<Scalars['String']>;
  pub: InputMaybe<PubTypeInput>;
  subKey: InputMaybe<Scalars['String']>;
  subKey2: InputMaybe<Scalars['String']>;
};

export type DeleteEntityInput = {
  data: Scalars['AWSJSON'];
  deleteDt: InputMaybe<Scalars['String']>;
  entityKey: Scalars['String'];
  entityName: EntityName;
  gsiKey: InputMaybe<Scalars['String']>;
  pub: InputMaybe<PubTypeInput>;
  subKey: InputMaybe<Scalars['String']>;
  subKey2: InputMaybe<Scalars['String']>;
};

export type DeleteOutputType = {
  id: Scalars['String'];
  key: Scalars['String'];
};

export type EntityDataPubType = {
  data: Scalars['AWSJSON'];
  pub: Maybe<PubType>;
};

export type EntityDataType = {
  data: Scalars['AWSJSON'];
};

export type EntityDeleteTypeInput = {
  id: Scalars['String'];
  key: Scalars['String'];
};

export type EntityListType = {
  items: Array<EntityType>;
  nextToken: Maybe<Scalars['String']>;
};

export enum EntityName {
  WagakoAppChildApplyFacilityEntity = 'WagakoAppChildApply_FacilityEntity',
  WagakoAppChildChildEntity = 'WagakoAppChild_ChildEntity',
  WagakoAppDefecationDefecationEntity = 'WagakoAppDefecation_DefecationEntity',
  WagakoAppDeviceDeviceEntity = 'WagakoAppDevice_DeviceEntity',
  WagakoAppDrugDrugEntity = 'WagakoAppDrug_DrugEntity',
  WagakoAppMealMealEntity = 'WagakoAppMeal_MealEntity',
  WagakoAppMeasureMeasureEntity = 'WagakoAppMeasure_MeasureEntity',
  WagakoAppMilkMilkEntity = 'WagakoAppMilk_MilkEntity',
  WagakoAppNewsContentEntity = 'WagakoAppNews_ContentEntity',
  WagakoAppNewsSentNewsEntity = 'WagakoAppNews_SentNewsEntity',
  WagakoAppNoticeNoticeCategoryEntity = 'WagakoAppNotice_NoticeCategoryEntity',
  WagakoAppNoticeNoticeItemEntity = 'WagakoAppNotice_NoticeItemEntity',
  WagakoAppSleepSleepWakeupEntity = 'WagakoAppSleep_SleepWakeupEntity',
  WagakoAppTemperatureTemperatureEntity = 'WagakoAppTemperature_TemperatureEntity',
  WagakoAppUserUserEntity = 'WagakoAppUser_UserEntity',
  WagakoNurseryAttendContactAttendContactAbsenceEntity = 'WagakoNurseryAttendContact_AttendContactAbsenceEntity',
  WagakoNurseryAttendContactAttendContactLateEntity = 'WagakoNurseryAttendContact_AttendContactLateEntity',
  WagakoNurseryAttendContactAttendContactLeaveEarlyEntity = 'WagakoNurseryAttendContact_AttendContactLeaveEarlyEntity',
  WagakoNurseryAttendHistoryAttendHistoryEntity = 'WagakoNurseryAttendHistory_AttendHistoryEntity',
  WagakoNurseryAttendRegisterAttendRegisterEntity = 'WagakoNurseryAttendRegister_AttendRegisterEntity',
  WagakoNurseryAttendanceSheetEntity = 'WagakoNurseryAttendance_SheetEntity',
  WagakoNurseryChildApplyChildApplyEntity = 'WagakoNurseryChildApply_ChildApplyEntity',
  WagakoNurseryChildApplyChildRemoveEntity = 'WagakoNurseryChildApply_ChildRemoveEntity',
  WagakoNurseryChildNotebookPageEntity = 'WagakoNurseryChildNotebook_PageEntity',
  WagakoNurseryChildExtendedChildcareEntity = 'WagakoNurseryChild_ExtendedChildcareEntity',
  WagakoNurseryChildTimeDivisionEntity = 'WagakoNurseryChild_TimeDivisionEntity',
  WagakoNurseryClassClassChildEntity = 'WagakoNurseryClass_ClassChildEntity',
  WagakoNurseryDefecationDefecationEntity = 'WagakoNurseryDefecation_DefecationEntity',
  WagakoNurseryDrugDrugEntity = 'WagakoNurseryDrug_DrugEntity',
  WagakoNurseryHomepageSettingsEntity = 'WagakoNurseryHomepage_SettingsEntity',
  WagakoNurseryMealMealEntity = 'WagakoNurseryMeal_MealEntity',
  WagakoNurseryMeasureMeasureEntity = 'WagakoNurseryMeasure_MeasureEntity',
  WagakoNurseryMilkMilkEntity = 'WagakoNurseryMilk_MilkEntity',
  WagakoNurseryPaymentPublicApiSettingsEntity = 'WagakoNurseryPayment_PublicApiSettingsEntity',
  WagakoNurseryPhotoPhotoEntity = 'WagakoNurseryPhoto_PhotoEntity',
  WagakoNurseryPhotoPhotoItemEntity = 'WagakoNurseryPhoto_PhotoItemEntity',
  WagakoNurseryPhotoPhotoOrderEntity = 'WagakoNurseryPhoto_PhotoOrderEntity',
  WagakoNurseryPhotoPhotoSalesEntity = 'WagakoNurseryPhoto_PhotoSalesEntity',
  WagakoNurseryPrivateBlogCategoryEntity = 'WagakoNurseryPrivateBlog_CategoryEntity',
  WagakoNurseryPrivateBlogPrivateBlogEntity = 'WagakoNurseryPrivateBlog_PrivateBlogEntity',
  WagakoNurserySleepSleepWakeupEntity = 'WagakoNurserySleep_SleepWakeupEntity',
  WagakoNurseryTemperatureTemperatureEntity = 'WagakoNurseryTemperature_TemperatureEntity'
}

export type EntityPubType = {
  pub: Maybe<PubType>;
};

export type EntitySubscribeType = {
  data: Scalars['AWSJSON'];
  id: Scalars['String'];
  key: Scalars['String'];
  pub: Maybe<PubType>;
};

export type EntityType = {
  createDt: Maybe<Scalars['AWSDateTime']>;
  data: Scalars['AWSJSON'];
  deleteDt: Maybe<Scalars['String']>;
  gsiId: Maybe<Scalars['String']>;
  gsiKey: Maybe<Scalars['String']>;
  id: Scalars['String'];
  key: Scalars['String'];
  pub: Maybe<PubType>;
  subKey: Maybe<Scalars['String']>;
  subKey2: Maybe<Scalars['String']>;
  updateDt: Maybe<Scalars['AWSDateTime']>;
};

export type EntityTypeInput = {
  createDt: InputMaybe<Scalars['AWSDateTime']>;
  data: Scalars['AWSJSON'];
  deleteDt: InputMaybe<Scalars['String']>;
  gsiId: InputMaybe<Scalars['String']>;
  gsiKey: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  key: Scalars['String'];
  pub: InputMaybe<PubTypeInput>;
  subKey: InputMaybe<Scalars['String']>;
  subKey2: InputMaybe<Scalars['String']>;
  updateDt: InputMaybe<Scalars['AWSDateTime']>;
};

export type Mutation = {
  createEntity: EntityType;
  createEntityAuth: EntityType;
  deleteEntity: DeleteOutputType;
  deleteEntityAuth: DeleteOutputType;
  updateEntity: EntityType;
  updateEntityAuth: EntityType;
};


export type MutationCreateEntityArgs = {
  input: CreateEntityInput;
};


export type MutationCreateEntityAuthArgs = {
  input: EntityTypeInput;
};


export type MutationDeleteEntityArgs = {
  input: DeleteEntityInput;
};


export type MutationDeleteEntityAuthArgs = {
  input: EntityDeleteTypeInput;
};


export type MutationUpdateEntityArgs = {
  input: UpdateEntityInput;
};


export type MutationUpdateEntityAuthArgs = {
  input: EntityTypeInput;
};

export type PubType = {
  data: Scalars['AWSJSON'];
  replyId: Scalars['String'];
  sendId: Scalars['String'];
};

export type PubTypeInput = {
  data: Scalars['AWSJSON'];
  replyId: Scalars['String'];
  sendId: Scalars['String'];
};

export type Query = {
  getEntities: EntityListType;
  getEntitiesWithKey: EntityListType;
  getEntitiesWithSubKey: EntityListType;
  getEntity: Maybe<EntityType>;
  getPublicEntities: EntityListType;
  getPublicEntitiesWithKey: EntityListType;
  getPublicEntitiesWithSubKey: EntityListType;
  getPublicEntity: Maybe<EntityType>;
};


export type QueryGetEntitiesArgs = {
  entityName: EntityName;
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
};


export type QueryGetEntitiesWithKeyArgs = {
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
};


export type QueryGetEntitiesWithSubKeyArgs = {
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
};


export type QueryGetEntityArgs = {
  entityKey: Scalars['String'];
  entityName: EntityName;
};


export type QueryGetPublicEntitiesArgs = {
  entityName: EntityName;
  id: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
};


export type QueryGetPublicEntitiesWithKeyArgs = {
  entityName: EntityName;
  id: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
};


export type QueryGetPublicEntitiesWithSubKeyArgs = {
  entityName: EntityName;
  id: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
};


export type QueryGetPublicEntityArgs = {
  entityKey: Scalars['String'];
  entityName: EntityName;
  id: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  onCreateEntity: Maybe<EntityType>;
  onCreateEntityAuth: Maybe<EntityType>;
  onDeleteEntity: Maybe<DeleteOutputType>;
  onDeleteEntityAuth: Maybe<DeleteOutputType>;
  onUpdateEntity: Maybe<EntityType>;
  onUpdateEntityAuth: Maybe<EntityType>;
};


export type SubscriptionOnCreateEntityArgs = {
  id: Scalars['String'];
};


export type SubscriptionOnCreateEntityAuthArgs = {
  id: Scalars['String'];
};


export type SubscriptionOnDeleteEntityArgs = {
  id: Scalars['String'];
};


export type SubscriptionOnDeleteEntityAuthArgs = {
  id: Scalars['String'];
};


export type SubscriptionOnUpdateEntityArgs = {
  id: Scalars['String'];
};


export type SubscriptionOnUpdateEntityAuthArgs = {
  id: Scalars['String'];
};

export type UpdateEntityInput = {
  data: Scalars['AWSJSON'];
  entityKey: Scalars['String'];
  entityName: EntityName;
  pub: InputMaybe<PubTypeInput>;
};

export type UpdateEntityPvtAuthInput = {
  data: Scalars['AWSJSON'];
  entityKey: Scalars['String'];
  entityName: EntityName;
  id: Scalars['String'];
  pub: InputMaybe<PubTypeInput>;
};

export type CreateEntityMutationVariables = Exact<{
  input: CreateEntityInput;
}>;


export type CreateEntityMutation = { createEntity: { id: string, key: string, createDt: string | null, updateDt: string | null, deleteDt: string | null, subKey: string | null, subKey2: string | null, gsiId: string | null, gsiKey: string | null, data: string, pub: { sendId: string, replyId: string, data: string } | null } };

export type UpdateEntityMutationVariables = Exact<{
  input: UpdateEntityInput;
}>;


export type UpdateEntityMutation = { updateEntity: { id: string, key: string, createDt: string | null, updateDt: string | null, deleteDt: string | null, subKey: string | null, subKey2: string | null, gsiId: string | null, gsiKey: string | null, data: string, pub: { sendId: string, replyId: string, data: string } | null } };

export type DeleteEntityMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteEntityMutation = { deleteEntity: { id: string, key: string } };

export type GetEntitiesQueryVariables = Exact<{
  entityName: EntityName;
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetEntitiesQuery = { getEntities: { nextToken: string | null, items: Array<{ data: string, pub: { sendId: string, replyId: string, data: string } | null }> } };

export type GetDataEntitiesQueryVariables = Exact<{
  entityName: EntityName;
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetDataEntitiesQuery = { getEntities: { nextToken: string | null, items: Array<{ data: string }> } };

export type GetPubEntitiesQueryVariables = Exact<{
  entityName: EntityName;
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetPubEntitiesQuery = { getEntities: { nextToken: string | null, items: Array<{ pub: { sendId: string, replyId: string, data: string } | null }> } };

export type GetEntitiesWithKeyQueryVariables = Exact<{
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetEntitiesWithKeyQuery = { getEntitiesWithKey: { nextToken: string | null, items: Array<{ data: string, pub: { sendId: string, replyId: string, data: string } | null }> } };

export type GetDataEntitiesWithKeyQueryVariables = Exact<{
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetDataEntitiesWithKeyQuery = { getEntitiesWithKey: { nextToken: string | null, items: Array<{ data: string }> } };

export type GetPubEntitiesWithKeyQueryVariables = Exact<{
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetPubEntitiesWithKeyQuery = { getEntitiesWithKey: { nextToken: string | null, items: Array<{ pub: { sendId: string, replyId: string, data: string } | null }> } };

export type GetEntitiesWithSubKeyQueryVariables = Exact<{
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetEntitiesWithSubKeyQuery = { getEntitiesWithSubKey: { nextToken: string | null, items: Array<{ data: string, pub: { sendId: string, replyId: string, data: string } | null }> } };

export type GetDataEntitiesWithSubKeyQueryVariables = Exact<{
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetDataEntitiesWithSubKeyQuery = { getEntitiesWithSubKey: { nextToken: string | null, items: Array<{ data: string }> } };

export type GetPubEntitiesWithSubKeyQueryVariables = Exact<{
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetPubEntitiesWithSubKeyQuery = { getEntitiesWithSubKey: { nextToken: string | null, items: Array<{ pub: { sendId: string, replyId: string, data: string } | null }> } };

export type GetEntityQueryVariables = Exact<{
  entityName: EntityName;
  entityKey: Scalars['String'];
}>;


export type GetEntityQuery = { getEntity: { data: string, pub: { sendId: string, replyId: string, data: string } | null } | null };

export type GetDataEntityQueryVariables = Exact<{
  entityName: EntityName;
  entityKey: Scalars['String'];
}>;


export type GetDataEntityQuery = { getEntity: { data: string } | null };

export type GetPubEntityQueryVariables = Exact<{
  entityName: EntityName;
  entityKey: Scalars['String'];
}>;


export type GetPubEntityQuery = { getEntity: { pub: { sendId: string, replyId: string, data: string } | null } | null };

export type GetPublicEntitiesQueryVariables = Exact<{
  id: InputMaybe<Scalars['String']>;
  entityName: EntityName;
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetPublicEntitiesQuery = { getPublicEntities: { nextToken: string | null, items: Array<{ data: string }> } };

export type GetPublicEntityQueryVariables = Exact<{
  id: InputMaybe<Scalars['String']>;
  entityName: EntityName;
  entityKey: Scalars['String'];
}>;


export type GetPublicEntityQuery = { getPublicEntity: { data: string } | null };

export type GetPublicEntitiesWithKeyQueryVariables = Exact<{
  id: InputMaybe<Scalars['String']>;
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetPublicEntitiesWithKeyQuery = { getPublicEntitiesWithKey: { nextToken: string | null, items: Array<{ data: string }> } };

export type GetPublicEntitiesWithSubKeyQueryVariables = Exact<{
  id: InputMaybe<Scalars['String']>;
  entityName: EntityName;
  key: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  nextToken: InputMaybe<Scalars['String']>;
}>;


export type GetPublicEntitiesWithSubKeyQuery = { getPublicEntitiesWithSubKey: { nextToken: string | null, items: Array<{ data: string }> } };

export type OnCreateEntitySubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type OnCreateEntitySubscription = { onCreateEntity: { id: string, key: string, data: string, pub: { sendId: string, replyId: string, data: string } | null } | null };

export type OnUpdateEntitySubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type OnUpdateEntitySubscription = { onUpdateEntity: { id: string, key: string, data: string, pub: { sendId: string, replyId: string, data: string } | null } | null };

export type OnDeleteEntitySubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type OnDeleteEntitySubscription = { onDeleteEntity: { id: string, key: string } | null };

export type OnCreateEntityAuthSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type OnCreateEntityAuthSubscription = { onCreateEntityAuth: { id: string, key: string, data: string, pub: { sendId: string, replyId: string, data: string } | null } | null };

export type OnUpdateEntityAuthSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type OnUpdateEntityAuthSubscription = { onUpdateEntityAuth: { id: string, key: string, data: string, pub: { sendId: string, replyId: string, data: string } | null } | null };

export type OnDeleteEntityAuthSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type OnDeleteEntityAuthSubscription = { onDeleteEntityAuth: { id: string, key: string } | null };


export const CreateEntityDocument = gql`
    mutation CreateEntity($input: CreateEntityInput!) {
  createEntity(input: $input) {
    id
    key
    createDt
    updateDt
    deleteDt
    subKey
    subKey2
    gsiId
    gsiKey
    data
    pub {
      sendId
      replyId
      data
    }
  }
}
    `;
export const UpdateEntityDocument = gql`
    mutation UpdateEntity($input: UpdateEntityInput!) {
  updateEntity(input: $input) {
    id
    key
    createDt
    updateDt
    deleteDt
    subKey
    subKey2
    gsiId
    gsiKey
    data
    pub {
      sendId
      replyId
      data
    }
  }
}
    `;
export const DeleteEntityDocument = gql`
    mutation DeleteEntity($input: DeleteEntityInput!) {
  deleteEntity(input: $input) {
    id
    key
  }
}
    `;
export const GetEntitiesDocument = gql`
    query GetEntities($entityName: EntityName!, $limit: Int, $nextToken: String) {
  getEntities(entityName: $entityName, limit: $limit, nextToken: $nextToken) {
    items {
      data
      pub {
        sendId
        replyId
        data
      }
    }
    nextToken
  }
}
    `;
export const GetDataEntitiesDocument = gql`
    query GetDataEntities($entityName: EntityName!, $limit: Int, $nextToken: String) {
  getEntities(entityName: $entityName, limit: $limit, nextToken: $nextToken) {
    items {
      data
    }
    nextToken
  }
}
    `;
export const GetPubEntitiesDocument = gql`
    query GetPubEntities($entityName: EntityName!, $limit: Int, $nextToken: String) {
  getEntities(entityName: $entityName, limit: $limit, nextToken: $nextToken) {
    items {
      pub {
        sendId
        replyId
        data
      }
    }
    nextToken
  }
}
    `;
export const GetEntitiesWithKeyDocument = gql`
    query GetEntitiesWithKey($entityName: EntityName!, $key: String!, $limit: Int, $nextToken: String) {
  getEntitiesWithKey(
    entityName: $entityName
    key: $key
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      data
      pub {
        sendId
        replyId
        data
      }
    }
    nextToken
  }
}
    `;
export const GetDataEntitiesWithKeyDocument = gql`
    query GetDataEntitiesWithKey($entityName: EntityName!, $key: String!, $limit: Int, $nextToken: String) {
  getEntitiesWithKey(
    entityName: $entityName
    key: $key
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      data
    }
    nextToken
  }
}
    `;
export const GetPubEntitiesWithKeyDocument = gql`
    query GetPubEntitiesWithKey($entityName: EntityName!, $key: String!, $limit: Int, $nextToken: String) {
  getEntitiesWithKey(
    entityName: $entityName
    key: $key
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      pub {
        sendId
        replyId
        data
      }
    }
    nextToken
  }
}
    `;
export const GetEntitiesWithSubKeyDocument = gql`
    query GetEntitiesWithSubKey($entityName: EntityName!, $key: String!, $limit: Int, $nextToken: String) {
  getEntitiesWithSubKey(
    entityName: $entityName
    key: $key
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      data
      pub {
        sendId
        replyId
        data
      }
    }
    nextToken
  }
}
    `;
export const GetDataEntitiesWithSubKeyDocument = gql`
    query GetDataEntitiesWithSubKey($entityName: EntityName!, $key: String!, $limit: Int, $nextToken: String) {
  getEntitiesWithSubKey(
    entityName: $entityName
    key: $key
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      data
    }
    nextToken
  }
}
    `;
export const GetPubEntitiesWithSubKeyDocument = gql`
    query GetPubEntitiesWithSubKey($entityName: EntityName!, $key: String!, $limit: Int, $nextToken: String) {
  getEntitiesWithSubKey(
    entityName: $entityName
    key: $key
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      pub {
        sendId
        replyId
        data
      }
    }
    nextToken
  }
}
    `;
export const GetEntityDocument = gql`
    query GetEntity($entityName: EntityName!, $entityKey: String!) {
  getEntity(entityName: $entityName, entityKey: $entityKey) {
    data
    pub {
      sendId
      replyId
      data
    }
  }
}
    `;
export const GetDataEntityDocument = gql`
    query GetDataEntity($entityName: EntityName!, $entityKey: String!) {
  getEntity(entityName: $entityName, entityKey: $entityKey) {
    data
  }
}
    `;
export const GetPubEntityDocument = gql`
    query GetPubEntity($entityName: EntityName!, $entityKey: String!) {
  getEntity(entityName: $entityName, entityKey: $entityKey) {
    pub {
      sendId
      replyId
      data
    }
  }
}
    `;
export const GetPublicEntitiesDocument = gql`
    query GetPublicEntities($id: String, $entityName: EntityName!, $limit: Int, $nextToken: String) {
  getPublicEntities(
    id: $id
    entityName: $entityName
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      data
    }
    nextToken
  }
}
    `;
export const GetPublicEntityDocument = gql`
    query GetPublicEntity($id: String, $entityName: EntityName!, $entityKey: String!) {
  getPublicEntity(id: $id, entityName: $entityName, entityKey: $entityKey) {
    data
  }
}
    `;
export const GetPublicEntitiesWithKeyDocument = gql`
    query GetPublicEntitiesWithKey($id: String, $entityName: EntityName!, $key: String!, $limit: Int, $nextToken: String) {
  getPublicEntitiesWithKey(
    id: $id
    entityName: $entityName
    key: $key
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      data
    }
    nextToken
  }
}
    `;
export const GetPublicEntitiesWithSubKeyDocument = gql`
    query GetPublicEntitiesWithSubKey($id: String, $entityName: EntityName!, $key: String!, $limit: Int, $nextToken: String) {
  getPublicEntitiesWithSubKey(
    id: $id
    entityName: $entityName
    key: $key
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      data
    }
    nextToken
  }
}
    `;
export const OnCreateEntityDocument = gql`
    subscription OnCreateEntity($id: String!) {
  onCreateEntity(id: $id) {
    id
    key
    data
    pub {
      sendId
      replyId
      data
    }
  }
}
    `;
export const OnUpdateEntityDocument = gql`
    subscription OnUpdateEntity($id: String!) {
  onUpdateEntity(id: $id) {
    id
    key
    data
    pub {
      sendId
      replyId
      data
    }
  }
}
    `;
export const OnDeleteEntityDocument = gql`
    subscription OnDeleteEntity($id: String!) {
  onDeleteEntity(id: $id) {
    id
    key
  }
}
    `;
export const OnCreateEntityAuthDocument = gql`
    subscription OnCreateEntityAuth($id: String!) {
  onCreateEntityAuth(id: $id) {
    id
    key
    data
    pub {
      sendId
      replyId
      data
    }
  }
}
    `;
export const OnUpdateEntityAuthDocument = gql`
    subscription OnUpdateEntityAuth($id: String!) {
  onUpdateEntityAuth(id: $id) {
    id
    key
    data
    pub {
      sendId
      replyId
      data
    }
  }
}
    `;
export const OnDeleteEntityAuthDocument = gql`
    subscription OnDeleteEntityAuth($id: String!) {
  onDeleteEntityAuth(id: $id) {
    id
    key
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    CreateEntity(variables: CreateEntityMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateEntityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEntityMutation>(CreateEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateEntity', 'mutation');
    },
    UpdateEntity(variables: UpdateEntityMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateEntityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEntityMutation>(UpdateEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateEntity', 'mutation');
    },
    DeleteEntity(variables: DeleteEntityMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteEntityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEntityMutation>(DeleteEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteEntity', 'mutation');
    },
    GetEntities(variables: GetEntitiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEntitiesQuery>(GetEntitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEntities', 'query');
    },
    GetDataEntities(variables: GetDataEntitiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDataEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDataEntitiesQuery>(GetDataEntitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDataEntities', 'query');
    },
    GetPubEntities(variables: GetPubEntitiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPubEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPubEntitiesQuery>(GetPubEntitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPubEntities', 'query');
    },
    GetEntitiesWithKey(variables: GetEntitiesWithKeyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetEntitiesWithKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEntitiesWithKeyQuery>(GetEntitiesWithKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEntitiesWithKey', 'query');
    },
    GetDataEntitiesWithKey(variables: GetDataEntitiesWithKeyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDataEntitiesWithKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDataEntitiesWithKeyQuery>(GetDataEntitiesWithKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDataEntitiesWithKey', 'query');
    },
    GetPubEntitiesWithKey(variables: GetPubEntitiesWithKeyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPubEntitiesWithKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPubEntitiesWithKeyQuery>(GetPubEntitiesWithKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPubEntitiesWithKey', 'query');
    },
    GetEntitiesWithSubKey(variables: GetEntitiesWithSubKeyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetEntitiesWithSubKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEntitiesWithSubKeyQuery>(GetEntitiesWithSubKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEntitiesWithSubKey', 'query');
    },
    GetDataEntitiesWithSubKey(variables: GetDataEntitiesWithSubKeyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDataEntitiesWithSubKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDataEntitiesWithSubKeyQuery>(GetDataEntitiesWithSubKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDataEntitiesWithSubKey', 'query');
    },
    GetPubEntitiesWithSubKey(variables: GetPubEntitiesWithSubKeyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPubEntitiesWithSubKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPubEntitiesWithSubKeyQuery>(GetPubEntitiesWithSubKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPubEntitiesWithSubKey', 'query');
    },
    GetEntity(variables: GetEntityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetEntityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEntityQuery>(GetEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEntity', 'query');
    },
    GetDataEntity(variables: GetDataEntityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDataEntityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDataEntityQuery>(GetDataEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDataEntity', 'query');
    },
    GetPubEntity(variables: GetPubEntityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPubEntityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPubEntityQuery>(GetPubEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPubEntity', 'query');
    },
    GetPublicEntities(variables: GetPublicEntitiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPublicEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPublicEntitiesQuery>(GetPublicEntitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPublicEntities', 'query');
    },
    GetPublicEntity(variables: GetPublicEntityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPublicEntityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPublicEntityQuery>(GetPublicEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPublicEntity', 'query');
    },
    GetPublicEntitiesWithKey(variables: GetPublicEntitiesWithKeyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPublicEntitiesWithKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPublicEntitiesWithKeyQuery>(GetPublicEntitiesWithKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPublicEntitiesWithKey', 'query');
    },
    GetPublicEntitiesWithSubKey(variables: GetPublicEntitiesWithSubKeyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPublicEntitiesWithSubKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPublicEntitiesWithSubKeyQuery>(GetPublicEntitiesWithSubKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPublicEntitiesWithSubKey', 'query');
    },
    OnCreateEntity(variables: OnCreateEntitySubscriptionVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OnCreateEntitySubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnCreateEntitySubscription>(OnCreateEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnCreateEntity', 'subscription');
    },
    OnUpdateEntity(variables: OnUpdateEntitySubscriptionVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OnUpdateEntitySubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnUpdateEntitySubscription>(OnUpdateEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnUpdateEntity', 'subscription');
    },
    OnDeleteEntity(variables: OnDeleteEntitySubscriptionVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OnDeleteEntitySubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnDeleteEntitySubscription>(OnDeleteEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnDeleteEntity', 'subscription');
    },
    OnCreateEntityAuth(variables: OnCreateEntityAuthSubscriptionVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OnCreateEntityAuthSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnCreateEntityAuthSubscription>(OnCreateEntityAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnCreateEntityAuth', 'subscription');
    },
    OnUpdateEntityAuth(variables: OnUpdateEntityAuthSubscriptionVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OnUpdateEntityAuthSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnUpdateEntityAuthSubscription>(OnUpdateEntityAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnUpdateEntityAuth', 'subscription');
    },
    OnDeleteEntityAuth(variables: OnDeleteEntityAuthSubscriptionVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OnDeleteEntityAuthSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnDeleteEntityAuthSubscription>(OnDeleteEntityAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnDeleteEntityAuth', 'subscription');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;